
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { globalVariables } from 'src/app/core/constants/globalVariables';
@Component({
  selector: 'app-cost-center-list',
  templateUrl: './../../../templates/forms/modals/invoice-dsitribution.component.html',
})
export class InvoiceDistributionComponent implements OnInit {
  @Input()
  modalShow: boolean = true;

  @Input()
  bankDocSetupValue;

  @Input()
  docNo;

  public dateFormat;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  invoiceDistributionList = [];

  searchFields: any[] = ['PI_ID', 'PI_VALUE'];
  public searchString;
  constructor(private commonService: CommonService,
    public langService: LangService) { }

  ngOnInit() {
    this.dateFormat =  globalVariables.dateFormat.dateFormat;
    if(this.bankDocSetupValue == 'P'){
      this.commonService.getPIByDocNo(this.docNo).subscribe(arg => { 
        this.invoiceDistributionList = arg.body;
        console.log("first - ", this.invoiceDistributionList);
      });
    }else{
      this.commonService.getInvoiceByDocNo(this.docNo).subscribe(arg => { 
        this.invoiceDistributionList = arg.body;
        console.log("Second - ", this.invoiceDistributionList);
      });
    }
   
  }
}


